import React, { useState } from "react";
import { Grid } from "@mui/material";
import { IoAdd } from "react-icons/io5";

import Button from "../../../../../components/Button-v2";
import Table from "../../../subcomponents/Table";
import Input from "../../ReadOnlyInput";
import EventsModalV2 from "../modal/EventsModalV2";
import { AddButtonWrapper, Separator } from "../styled";
import { timeStampToDateWithTime } from "../../../../../utils/formats";

const style = {
  justify: "center",
};

const eventsColumns = [
  { id: "codigoEvento", name: "Evento", style },
  { id: "descricao", name: "Descrição do evento" },
  {
    id: "dataEvento",
    name: "Data evento",
    render: timeStampToDateWithTime,
    style,
  },
  { id: "nomeFuncionario", name: "Funcionário" },
  { id: "origem", name: "Origem", style },
];

const EventsSection = (props) => {
  const [selectedEvent, setSelectedEvent] = useState(undefined);
  const [eventsModalOpen, setEventsModalOpen] = useState(false);

  const {
    cpfCnpj,
    events,
    eventsLoading,
    eventTypes,
    eventTypesLoading,
    reloadEvents,
  } = props;

  return (
    <>
      <AddButtonWrapper>
        <Button
          height="35px"
          minWidth="215px"
          fontSize="11px"
          type="button"
          onClick={() => setEventsModalOpen(true)}
          leftIcon={IoAdd}
        >
          Adicionar evento
        </Button>
      </AddButtonWrapper>
      <Separator />
      <Grid container spacing={1}>
        <Grid item xs={12} md={7}>
          <Table
            maxHeight="300px"
            loadingRows={5}
            noDataMessage="Sem dados"
            columns={eventsColumns}
            loading={eventsLoading}
            entries={events}
            onRowClick={setSelectedEvent}
            selectedRow={selectedEvent}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <Input
            label="Observações do evento selecionado"
            height={200}
            type="textarea"
            value={selectedEvent?.observacao || "-"}
          />
        </Grid>
      </Grid>
      <EventsModalV2
        cpfCnpj={cpfCnpj}
        open={eventsModalOpen}
        onClose={() => setEventsModalOpen(false)}
        eventTypes={eventTypes}
        eventTypesLoading={eventTypesLoading}
        reloadEvents={reloadEvents}
      />
    </>
  );
};

export default EventsSection;
